import { theme } from '../../../theme';
import SvgAlert from '../../../assets/alert.svg';
export const getErrorStyles = (error, touched) => {
    if (error && touched) {
        return {
            outline: `2px solid ${theme.colors.NE100}`,
            // border: 'none'
        };
    }
    return {};
};
export const inputStyles = () => `
	display: flex;
	flex-direction: row;

	line-height: 150%;

	width: 100%;
	border: solid 1px;
	border-radius: ${theme.radii.radii30};
	border-color: ${theme.colors.LM_NU30};

	color: #11233a;
	background-color: ${theme.colors.LM_NU10};
	outline-offset: -2px;
	
	:hover {
		background-color: ${theme.colors.LM_NU20};
	}

	:active {
		outline: 2px solid ${theme.colors.BB100};
		background-color: ${theme.colors.LM_NU20};
	}
	:focus-within {
		outline: 2px solid ${theme.colors.BB80};
		background-color: ${theme.colors.LM_NU20};
	}`;
export const getErrorIconStyles = (error, touched) => {
    if (error && touched) {
        return {
            content: `url("${SvgAlert}")`,
            position: 'absolute',
            display: 'block',
            width: '16px',
            height: '16px',
            right: '1rem',
            top: '13px',
        };
    }
    return {};
};
//# sourceMappingURL=styles.js.map